// extracted by mini-css-extract-plugin
module.exports = {"viewports":"\"../../../viewports.css\"","desktop":"1024px","settings-container":"settings-container_settings-container__hSFmi"};